'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of chat bubbles
 */ const ChatBubbles = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 105 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M104.746 52C104.746 80.7188 81.4649 104 52.7461 104C24.0273 104 0.746094 80.7188 0.746094 52C0.746094 23.2812 24.0273 0 52.7461 0C81.4649 0 104.746 23.2812 104.746 52Z",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("g", {
                opacity: "0.7",
                children: /*#__PURE__*/ jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M78.8261 43.5371C83.8042 43.5371 87.8398 47.5727 87.8398 52.5509V68.0723C87.8398 72.8193 84.1702 76.7093 79.513 77.0603L79.5009 82.5077C79.4969 84.2641 77.3408 85.104 76.1497 83.8132L70.5361 77.729C70.3531 77.5306 70.222 77.3125 70.1377 77.0861H58.2494C53.2712 77.0861 49.2356 73.0505 49.2356 68.0723V52.5509C49.2356 47.5727 53.2712 43.5371 58.2494 43.5371H78.8261Z",
                    fill: theme.ds5.asset[assetColor]["500"]
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M26.7286 22.6016C21.7505 22.6016 17.7148 26.6372 17.7148 31.6154V59.0412C17.7148 64.0194 21.7504 68.055 26.7286 68.055H28.9985L29.0187 77.1419C29.0226 78.8983 31.1788 79.7383 32.3698 78.4474L41.9585 68.055H61.0036C65.9818 68.055 70.0174 64.0194 70.0174 59.0412V31.6154C70.0174 26.6372 65.9818 22.6016 61.0036 22.6016H26.7286Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("g", {
                clipPath: "url(#clip0_3481_525)",
                children: /*#__PURE__*/ jsxRuntime.jsx("path", {
                    d: "M51.8699 44.0117C51.8699 44.0117 51.8699 44.0444 51.8699 44.077C51.8699 44.3385 51.4714 49.8291 44.5988 52.313V48.8813L48.749 44.4365C49.1142 44.0444 49.1142 43.4234 48.6826 43.0312C48.2842 42.6717 47.6533 42.6717 47.2549 43.0966L44.5988 45.9726V43.0312C44.5988 43.0312 44.5988 43.0312 44.5988 42.9985C44.9309 42.2468 46.5245 39.3054 50.4422 39.3054C50.4754 39.3054 50.5086 39.3054 50.5418 39.3054C52.1023 41.1356 51.8699 43.979 51.8699 44.0117ZM42.6068 45.9726L39.9175 43.0966C39.5523 42.7044 38.9215 42.6717 38.5231 43.0312C38.1246 43.3907 38.0914 44.0444 38.4567 44.4365L42.6068 48.8813V52.2803C35.7342 49.7964 35.369 44.2731 35.3358 44.0444C35.3358 44.0117 35.3358 44.0117 35.3358 43.979C35.3358 43.9463 35.0702 41.103 36.6306 39.2727C36.6638 39.2727 36.697 39.2727 36.7634 39.2727C40.7143 39.2727 42.2748 42.2468 42.6068 42.9658C42.6068 42.9658 42.6068 42.9658 42.6068 42.9985V45.9726ZM51.7371 37.606C51.571 37.4425 51.3386 37.3445 51.1062 37.3118C47.3545 37.083 44.8976 38.9786 43.6028 40.7434C42.308 38.9786 39.8843 37.083 36.0994 37.3118C35.867 37.3118 35.6346 37.4425 35.4686 37.606C33.0449 39.9918 33.3105 43.7829 33.3437 44.1424C33.3437 44.4039 33.5097 46.2667 34.7381 48.4238C35.9002 50.4828 38.3571 53.1954 43.2376 54.568C43.2708 54.568 43.304 54.568 43.304 54.6007C43.3372 54.6007 43.3372 54.6007 43.3704 54.6007C43.4036 54.6007 43.4036 54.6007 43.4368 54.6007C43.47 54.6007 43.5364 54.6007 43.5696 54.6007C43.6028 54.6007 43.6692 54.6007 43.7024 54.6007C43.7356 54.6007 43.7356 54.6007 43.7688 54.6007C43.802 54.6007 43.802 54.6007 43.8352 54.6007C43.8684 54.6007 43.9016 54.6007 43.9348 54.568C52.9987 52.0515 53.7955 44.8614 53.8287 44.1751C53.8619 43.979 54.1939 40.0571 51.7371 37.606Z",
                    fill: theme.ds5.asset.grey["700"]
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3481_525",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "20.9166",
                        height: "17.6484",
                        fill: "white",
                        transform: "translate(33.1445 37.1484)"
                    })
                })
            })
        ]
    });
};

exports.ChatBubbles = ChatBubbles;
//# sourceMappingURL=ChatBubbles.cjs.map
